const CHECKS = [
  'Open the game on your site with a regular player account: players on the Test Players list and promotion players never fire the pixels.',
  'Changes apply to games opened after you save — reload the game.',
  'Meta: Events Manager → your pixel → Test events, or the Meta Pixel Helper browser extension.',
  'Reddit: the Reddit Pixel Helper browser extension.',
  'Google: Tag Assistant (tagassistant.google.com); in GA4 also Reports → Realtime.',
  'Ad blockers stop pixels — for some of your players too. Turn yours off while checking.',
];

export function VerifyGuide() {
  return (
    <section className="rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4 text-[12px] text-[var(--co-muted)]">
      <p className="mb-2 font-semibold text-[var(--co-text)]">Check that it works</p>
      <ul className="list-disc space-y-1 pl-4">
        {CHECKS.map((check) => (
          <li key={check}>{check}</li>
        ))}
      </ul>
    </section>
  );
}
